module.exports = __webpack_public_path__ + "media/images/social/whatsapp-square-brands-005d5d26753c8e06a3c0fd007caa4f0a.svg";